import HeaderScroll from "./components/HeaderScroll.js";
import Toggle from "./components/Toggle.js";
import GformUpload from "./components/GformUpload.js";
import SmoothScroll from "./components/SmoothScroll.js";
import ImageGalleryVideoSlider from "../../../frontend/blocks/image-gallery-video/image-gallery-video";
import MediaTextarea from "../../../frontend/blocks/media-textarea/media-textarea";
import Testimonials from '../../../frontend/blocks/testimonials/testimonials.js';
import Animate from "./components/Animate.js";
import IconColumns from "../../../frontend/blocks/icon-columns/icon-columns.js";
import MediaColumns from "../../../frontend/blocks/media-columns/media-columns.js";
import ImageSlide from './components/Wipe.js';

{ Animate(); }

{
    const iconColumns = document.querySelector('.icon-columns');

    if (typeof iconColumns != "undefined" && iconColumns != null) {
        IconColumns(iconColumns);
    }
}


{
    const mediaTextarea = document.querySelector(".media-textarea__swiper");

    if (typeof mediaTextarea != "undefined" && mediaTextarea != null) {
        MediaTextarea();
    }
}

{
    const mediaColumns = document.querySelector(".media-columns__swiper");

    if (typeof mediaColumns != "undefined" && mediaColumns != null) {
        MediaColumns();
    }
}

{
    const header = document.querySelector(".header");

    if (typeof header != "undefined" && header) {
        HeaderScroll();
    }
}


{
    const toggle_element = document.querySelector("[data-toggle]");

    if (typeof toggle_element != "undefined" && toggle_element) {
        Toggle();
    }
}


{
    if (typeof gform != "undefined" && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector("[data-smooth-scroll]");

    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const imageGalleryVideoSlider = document.querySelector(
        ".image-gallery-video__swiper-wrapper"
    );

    if (
        typeof imageGalleryVideoSlider != "undefined" &&
        imageGalleryVideoSlider != null
    ) {
        ImageGalleryVideoSlider(imageGalleryVideoSlider);
    }
}

{
    const testimonials = document.querySelector('.testimonials__swiper');
    if (typeof testimonials != "undefined" && testimonials != null) {
        Testimonials(testimonials);
    }
}


{
    const imagesToWipe = document.querySelectorAll('.image-wipe');

    if (typeof imagesToWipe != "undefined" && imagesToWipe != null) {
        ImageSlide();
    }
}